import ThemeToggle from '@/core/components/theme-toggle';
import ChooseLanguageRegion from '@/core/components/modal/modal-topbar/choose-language-region';
import ChooseRegionProvider from '@/providers/choose-region/provider';
import PrivacyToggle from '@/core/components/privacy-toggle';

export default function SidebarSettings() {
  return (
    <div className="sidebar-settings">
      <ChooseRegionProvider>
        <ChooseLanguageRegion />
      </ChooseRegionProvider>
      <ThemeToggle />
      <PrivacyToggle />
    </div>
  );
}
